module.exports = __webpack_public_path__ + "assets/img/home_t_i.b4723d43.png";